@if (isLoading()) {
  <app-loading />
} @else {
  <app-panel titleKey="common.provider" [collapsed]="true">
    <p-table [value]="rows()" sortField="submissionDate" [sortOrder]="1">
      <ng-template #header>
        <tr>
          <th pSortableColumn="providerName">
            {{ 'common.provider' | transloco }}
            <p-sortIcon field="providerName" />
          </th>
          <th pSortableColumn="submissionDate">
            {{ 'common.status' | transloco }}
            <p-sortIcon field="submissionDate" />
          </th>
        </tr>
      </ng-template>
      <ng-template #body let-row>
        <tr>
          <td>{{ row.providerName }}</td>
          <td [style.color]="getStatusColor(row.status)">
            {{ row.status }}
            @if (getStatusTooltip(row); as statusTooltip) {
              <i
                class="pi pi-info-circle ml-1"
                [ngClass]="getSubmissionDateColorClass(row)"
                [pTooltip]="statusTooltip"
                [escape]="false"
                tooltipPosition="top"
              ></i>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </app-panel>
}
